export const COLORS_RADAR_GRAPH = [
  "#ffadad",
  "#ffd6a5",
  "#fdffb6",
  "#caffbf",
  "#9bf6ff",
  "#a0c4ff",
  "#bdb2ff",
  "#ffc6ff",
  "#eae4e9",
  "#fff1e6",
  "#fde2e4",
  "#fad2e1",
  "#e2ece9",
  "#bee1e6",
  "#f0efeb",
  "#dfe7fd",
  "#cddafd",
];

export const hexToRGBA = (hex: string[], opacity: number) => {
  const rgba = hex.map((hex) => {
    let c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      c = hex.substring(1).split("");
      if (c.length === 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c = `0x${c.join("")}`;
      return (
        // eslint-disable-next-line no-bitwise
        `rgba(${[(c >> 16) & 255, (c >> 8) & 255, c & 255].join(
          ","
        )},${opacity})`
      );
    }
    return "rgba(0,0,0,0)";
  });
  return rgba;
};

//
